import styled from "styled-components";

export const PageTitleH2 = styled.h2`
  text-align: center;
`;
